const en = {
  subTitle: '(UXCG - Finding solutions for your problems)',
  description: `UXCG is a free tool that allows you to look at the most popular issues in product and project management from the perspective of cognitive science and behavioral economics.`,
  defaultStage: 'Team Assembly',
  selectStageTxt: 'Select your project stage',
  relevantQuestionsTxt: 'Relevant questions for your project',
};

export default en;
